import { Properties } from "v2/infrastructure/common/types/FunctionPropertiesType";

export default class Employee {
  id: string;

  name: string;

  surname: string;

  legalId: string;

  email: string;

  constructor({
    id = "",
    name = "",
    surname = "",
    legalId = "",
    email = "",
  }: Properties<Employee>) {
    this.id = id;
    this.name = name;
    this.surname = surname;
    this.legalId = legalId;
    this.email = email;
  }
}
